import { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { TypoBody, TypoCallout, TypoTitle } from '@/components/Typography.tsx';
import Button from '@/components/Button.tsx';
import useAuth from '@/hooks/useAuth.ts';
import { LADDER_APP_STORE_URL, LADDER_PLAY_STORE_URL, rememberReferralCode } from '@/utils/referral.ts';

/**
 * Landing page for referral share links (`/join/<CODE>`). The code is remembered so the signup form can
 * prefill it; it is passed on as read, since the server normalises case and separators.
 */
const Join = () => {
  const { code = '' } = useParams();
  const auth = useAuth();

  useEffect(() => {
    if (code) rememberReferralCode(code);
  }, [code]);

  return (
    <div className="flex flex-col items-center gap-6 w-full max-w-md py-10 text-center">
      <div className="flex flex-col gap-2">
        <TypoTitle className="text-neutral-text-strong">You’re invited to the SATPrac Ladder</TypoTitle>
        <TypoBody className="text-neutral-text">
          Climb the ranks in head-to-head SAT matches, solo runs and tournaments. Get the app to start playing.
        </TypoBody>
      </div>

      {code && (
        <div className="flex flex-col gap-1 px-6 py-3 rounded bg-neutral2">
          <TypoCallout className="text-neutral2-text-softer">Your invite code</TypoCallout>
          <strong className="text-heading tracking-wider text-neutral2-text-strong">{code}</strong>
        </div>
      )}

      <div className="flex flex-wrap justify-center gap-3">
        {LADDER_APP_STORE_URL && (
          <a href={LADDER_APP_STORE_URL} target="_blank" rel="noreferrer">
            <Button>Download on the App Store</Button>
          </a>
        )}
        {LADDER_PLAY_STORE_URL && (
          <a href={LADDER_PLAY_STORE_URL} target="_blank" rel="noreferrer">
            <Button>Get it on Google Play</Button>
          </a>
        )}
      </div>

      {auth.clientId ? (
        <TypoCallout className="text-neutral-text-soft">
          You’re already signed in. <Link to="/ladder" className="font-semibold text-primary">Open the Ladder</Link>
        </TypoCallout>
      ) : (
        <TypoCallout className="text-neutral-text-soft">
          Prefer the website?{' '}
          <Link to="/sign-up" className="font-semibold text-primary">Sign up here</Link>
          {code && ' and your code will be filled in for you.'}
        </TypoCallout>
      )}
    </div>
  );
};

export default Join;
